var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-bottom"},[_c('img',{staticClass:"footer-logo",attrs:{"src":"/static_img/skinc/footer/Logo_ENG.png","alt":"SK Logo"}}),_c('div',{staticClass:"footer-text"},[_vm._v(" 26, JONG-RO, JONGRO-GU, SEOUL, 03188, REPUBLIC OF KOREA"),_c('br'),_vm._v(" COPYRIGHT Ⓒ BY SK INC. ALL RIGHTS RESERVED ")])])
}]

export { render, staticRenderFns }